import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ZakazkaArchiv = {
	name: NAME,
	apiProvider,
	router,
};
